import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { fetchWithAuth } from "../api/fetchWithAuth";

const initialForm = {
  name: "",
  note: ""
};

function DeviceFormModal({ show, onClose, onSaved, device }) {
  const isEdit = Boolean(device);
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (device) {
      setForm({
        name: device.name ?? "",
        note: device.note ?? ""
      });
    } else {
      setForm(initialForm);
    }
  }, [device, show]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((current) => ({
      ...current,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    const url = isEdit
      ? `/api/devices/${device.id}`
      : "/api/devices";
    const method = isEdit ? "PUT" : "POST";

    const res = await fetchWithAuth(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      alert(error?.error || "Save failed");
      return;
    }

    onSaved();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {isEdit ? "Edit Device" : "Add Device"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Note</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="note"
              value={form.note}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeviceFormModal;
